let viewFolder = "Room";

module.exports = [
    {
        path: '/warehouses/view/:warehouseId/rooms/view/:id',
        name: 'room',
        component: () => import(/* webpackChunkName: "Warehouse" */ '../views/'+viewFolder+'/View.vue'),
        // beforeEnter: (to, from, next) => {
        //   if (!localStorage.getItem('userId')) next({ name: 'Home' })
        //   else next()
        // }
    }
]